// @flow
export { default } from './HideScrollbar';



// WEBPACK FOOTER //
// ./src/components/common/HideScrollbar/index.js